import React, { useEffect } from 'react'
import { fieldDataState } from '../../../globalStates/general/fieldData';
import { player1CurrentSquaresState } from '../../../globalStates/general/player1CurrentSquare';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { easyPlayerHasWordsState } from '../../../globalStates/gameMain/playerHasWordsContent';
import { player1HasWordsState } from '../../../globalStates/general/hasWords';
import { gameStatusInfoState } from '../../../globalStates/general/gameStatusInfo';
import { warpWindowDisplayState } from '../../../globalStates/item/warpWindowDisplay';
import { isReverseState } from '../../../globalStates/general/reverse';
import { mpState } from '../../../globalStates/general/mp';
import { selectedSquaresState } from '../../../globalStates/general/selectedSquares';
import { gameStatusState } from '../../../globalStates/general/gameStatus';


export const nameToTrapIdTable = {
  "はじめのマス": 1,
  "最後のマス": 2,
  "単語を失う": 3,
  "ゲームオーバー": 4,
  "❓": 5,
}
// trap id と名前の対応表
export const trapIdToNameTable = {
  1: "はじめのマス",
  2: "最後のマス",
  3: "単語を失う",
  4: "ゲームオーバー",
  5: "❓",
}

export const trapIdListForRandom = [
  1, 1, 1, 1, 1, 1, 1,
  2, 2, 2, 2, 2, 2, 2,
  3, 3, 3, 3, 3,
  5, 5, 5,
  4,
]


const TrapMain = () => {
  const fieldData = useRecoilValue(fieldDataState);
  const playerCurrentIndex = useRecoilValue(player1CurrentSquaresState);
  const [player, setPlayerSquare] = useRecoilState(player1CurrentSquaresState);

  const [haveWords, setHaveWords] = useRecoilState(player1HasWordsState);
  // ユーザーに提示するためのゲームの状態
  const [gameStatusInfo, setGameStatusInfo] = useRecoilState(gameStatusInfoState);
  const [isReverse, setIsReverse] = useRecoilState(isReverseState);
  const [mp, setMp] = useRecoilState(mpState);
  const setSelectedSquare = useSetRecoilState(selectedSquaresState);
  const [gameStatusValue, setGameStatusValue] = useRecoilState(gameStatusState);

  // trap id と名前の対応表

  const TrapIdToFunc = {

    1: () => {// 一番最初に戻る
      warpToFirstGrid();
    },
    2: () => {// 一番最後に戻る
      warpToFinalGrid();
    },
    3: () => {// ゲットした単語を1つ失う
      lostWord();
    },
    4: () => {
      gameOver();
    },
    5: () => {
      hatenaBox();
    }

  }

  const warpToFirstGrid = () => {
    setPlayerSquare(1);
    setGameStatusInfo("最初のマスにワープしました。");
  }
  const warpToFinalGrid = () => {
    setPlayerSquare(fieldData.length - 1);
    setGameStatusInfo("最後のマスにワープしました。");
  }
  const lostWord = () => {
    if (haveWords.length === 0) return;
    const wordIndex = Math.floor(Math.random() * haveWords.length);
    setGameStatusInfo(haveWords[wordIndex].contents + "が削除されました。");
    let tmpArr = [...haveWords];
    tmpArr.splice(wordIndex, 1);
    setHaveWords(tmpArr);
  }
  const mpRandomPlus = () => {
    console.log("mp plus function");
  }
  const gameOver = () => {
    setGameStatusValue(8);
  }
  const hatenaBox = () => {

    const hatenaArr = ["適当な場所に飛ぶ", "MPが加算", "進むマスが逆になる", "単語を失う"];

    const objLen = hatenaArr.length;
    const getRandomHatenaId = Math.floor(Math.random() * objLen);

    setGameStatusInfo(hatenaArr[getRandomHatenaId]);
    let rand = 0;
    switch (getRandomHatenaId) {

      case 0:
        while (1) {
          rand = Math.floor(Math.random() * fieldData.length);
          if (rand > 0 && rand <= fieldData.length - 1) {
            break;
          }
        }
        setPlayerSquare(rand);
        break;
      case 1:
        setMp(mp + 50);
        break;
      case 2:
        if (isReverse) {
          setIsReverse(false);

          setGameStatusInfo("➡️");

        }
        else {
          setIsReverse(true);
          setGameStatusInfo("⬅️");


        }
        break;
      case 3:
        lostWord();
        break;



    }
  }

  useEffect(() => {
    if (fieldData[playerCurrentIndex].isTrap) {
      // fieldData[playerCurrentIndex].contents → trap name
      // name to trap table: translate trap id to name
      // execute the both of function trap
      TrapIdToFunc[nameToTrapIdTable[fieldData[playerCurrentIndex].contents]]();


    }
  }, [playerCurrentIndex]);
  return (
    <div></div>
  )
}

export default TrapMain
